// Icon set of the interface: names used by manifests and screens map to one icon library in one place.

import {
  ArrowDownUp, ArrowLeft, ArrowUpRight, ChevronsLeft, ChevronsRight, ChevronsUpDown, Download, ChevronLeft, Book, Building2, Calendar, Check, CheckSquare, ChevronDown, ChevronUp, ChevronRight, CircleDot, Columns3,
  Command, Copy, Ellipsis, ExternalLink, Eye, EyeOff, Filter, GripVertical, Handshake, Hash, Kanban, LayoutList, Link2,
  ListFilter, LogOut, Mail, Maximize2, Minimize2, Moon, PanelLeft, PanelRight, Phone, Plus, Search, Settings, Settings2,
  Pencil, Sparkles, Square, Sun, Tag, Trash2, Type, User, Users, Wallet, X, Archive, Undo2, Globe, AlignLeft, Monitor, Zap, Table2, ClipboardList, Inbox, Lock, LayoutGrid,
  type LucideIcon,
} from 'lucide-react';
import { Code, Heading1, Heading2, Heading3, Image, Lightbulb, List, ListOrdered, ListTodo, Minus, Pilcrow, Quote } from 'lucide-react';
import { Ban, File, FileText, Forward, MailOpen, Paperclip, RefreshCw, Reply, ReplyAll, Send, SquarePen, Star } from 'lucide-react';
// Kinds of files (um/2026-10-30/03 п.8): the icon of a file without a thumbnail, the gallery view.
import { FileArchive, FileAudio, FileImage, FileType2, FileVideo } from 'lucide-react';
// Rail sections (um/2026-10-30/05): a ticket, a microphone for the program, a shelf of books for directories next to the one book of knowledge.
import { LibraryBig, Mic, Ticket } from 'lucide-react';
// «Мои сделки», «Мои задачи» (R-U29); «Аналитика» (R-AN1).
import { ChartColumn, UserCheck } from 'lucide-react';

const ICONS: Record<string, LucideIcon> = {
  edit: Pencil, building: Building2, user: User, users: Users, handshake: Handshake, check: CheckSquare, book: Book, square: Square,
  search: Search, plus: Plus, settings: Settings, lock: Lock, gear: Settings2, filter: ListFilter, filterAlt: Filter, sort: ArrowDownUp,
  close: X, chevronDown: ChevronDown, chevronUp: ChevronUp, chevronRight: ChevronRight, chevronLeft: ChevronLeft, chevronsLeft: ChevronsLeft, chevronsRight: ChevronsRight, chevronsUpDown: ChevronsUpDown, more: Ellipsis, expand: Maximize2, collapse: Minimize2,
  panel: PanelRight, sidebar: PanelLeft, sun: Sun, moon: Moon, monitor: Monitor, logout: LogOut, board: Kanban, table: Table2,
  list: LayoutList, columns: Columns3, grip: GripVertical, eye: Eye, eyeOff: EyeOff, trash: Trash2, archive: Archive, undo: Undo2,
  download: Download, link: Link2, external: ExternalLink, copy: Copy, mail: Mail, phone: Phone, globe: Globe, text: Type, longtext: AlignLeft,
  number: Hash, money: Wallet, date: Calendar, tag: Tag, stage: CircleDot, tick: Check, back: ArrowLeft, open: ArrowUpRight, command: Command,
  sparkles: Sparkles, zap: Zap, form: ClipboardList, inbox: Inbox, cards: LayoutGrid,
  fileImage: FileImage, fileVideo: FileVideo, fileAudio: FileAudio, filePdf: FileType2, fileArchive: FileArchive, grid: LayoutGrid,
  ticket: Ticket, mic: Mic, library: LibraryBig, mine: UserCheck, chart: ChartColumn,
};

// Blocks of the long text editor (decision 034).
Object.assign(ICONS, {
  paragraph: Pilcrow, h1: Heading1, h2: Heading2, h3: Heading3, bullets: List, numbers: ListOrdered, todo: ListTodo, quote: Quote,
  callout: Lightbulb, code: Code, divider: Minus, image: Image,
} satisfies Record<string, LucideIcon>);

// The mail client (R-M6): writing, answering, marks and files of a letter.
Object.assign(ICONS, {
  compose: SquarePen, send: Send, draft: File, junk: Ban, star: Star, starFilled: Star, paperclip: Paperclip, reply: Reply, replyAll: ReplyAll,
  forward: Forward, mailRead: MailOpen, mailUnread: Mail, refresh: RefreshCw, file: FileText,
} satisfies Record<string, LucideIcon>);

export const FIELD_ICONS: Record<string, string> = {
  text: 'text', longtext: 'longtext', number: 'number', money: 'money', date: 'date', datetime: 'date', email: 'mail',
  phone: 'phone', url: 'globe', checkbox: 'tick', taxonomy: 'tag', relation: 'link', user: 'user', query: 'filter',
};

export function Icon({ name, size = 16, className, strokeWidth = 1.75 }: { name: string; size?: number; className?: string; strokeWidth?: number }) {
  const C = ICONS[name] ?? Square;
  // «Важное» that is on is the same star, filled.
  return <C size={size} strokeWidth={strokeWidth} className={className} aria-hidden {...(name === 'starFilled' ? { fill: 'currentColor' } : {})} />;
}
